import React, {Component} from 'react'
import {throttle} from 'lodash'

export default class FaqItem extends Component {
  componentDidMount() {
    this.calcMaxHeight()
  }

  toggleAccordion = () => {
    this.props.setActiveItem(this.props.currentItem !== this.props.activeItem ? this.props.currentItem : null)
  }

  calcMaxHeight = () => {
    this.maxHeight = this.innerContent.offsetHeight
  }

  onResize = throttle(() => {
    this.calcMaxHeight()
  }, 400)

  render() {
    const { 
      themes,
      activeTheme,
      question,
      answer,
    } = this.props

    if (this.content) {
      if (this.props.currentItem === this.props.activeItem) {
        this.content.style.maxHeight = `${this.maxHeight}px`
      } else {
        this.content.style.maxHeight = 0
      }
    }
  
    return (
      <div className={`accordion-item ${this.props.activeItem === this.props.currentItem ? 'is-open' : ''} ${activeTheme !== 'all' && !themes.includes(activeTheme) ? 'is-hidden' : ''}`}>
        <button className="accordion-title" onClick={() => this.toggleAccordion()}>
          {question} <span className="accordion-title-icon"></span>
        </button>
        <div className="accordion-content" ref={ (content) => this.content = content }>
          <div className="accordion-content-inner" ref={ (innerContent) => this.innerContent = innerContent } dangerouslySetInnerHTML={{ __html: answer }}>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FaqItem.js